export const IBAI_USER_ID = '8eacfa79-cf8b-4527-8ffb-483724e7ee6e';
export const IBAI_USERNAME = 'ibaillanos';
